document.addEventListener("turbolinks:load", () => {
  if ($('#date_of_mating').length > 0) {
    const initialDate = new Date($('#date_of_mating').text());
    const date = new Date($('#date_of_mating').text());
    const today = new Date();
    date.setDate(date.getDate() + 63);
    const dayDifference = (today.getTime() - initialDate.getTime()) / (1000*60*60*24*7)
    let week = Math.ceil(dayDifference);
    if (week === 10) {
      week = 9;
    }
    let trimester;
    if (week < 4) {
      trimester = 1
    } else if (week < 7) {
      trimester = 2
    } else {
      trimester = 3
    }
    $("#due-ans").text(date.toDateString());
    $("#pregnancy-week").text(`${week}`);
    $("#trimester").text(`${trimester}`);
    $('.answer-container').slideDown(350);

    $([document.documentElement, document.body]).animate({
      scrollTop: $("#due-ans").offset().top - 200
    }, 350);
  }
});
